import * as React from 'react';
import { useField } from 'formik';

import { Spinner } from 'components/common';
import { useGetEventProcedure } from 'security-app/hooks/useEventProceduresAPI';

import Form from './Form';
import { INIT_EVENT_PROCEDURE } from './utils';

type Props = {
  field: any & { value: string };
  onClose: (newEventProcedureId?: string) => void;
  remediationSteps?: string;
  onRemove?: () => void;
};

function EventProcedureFormField({ field, onClose, remediationSteps = undefined, onRemove = undefined }: Props) {
  const [{ value: eventProcedureId }, _m, { setValue, setTouched }] = useField({ name: field.name });
  const { eventProcedure, loadingEventProcedure } = useGetEventProcedure(eventProcedureId);

  const onChange = React.useCallback(
    (newEventProcedureId: string) => {
      setValue(newEventProcedureId);
      setTouched(true);
      onClose(newEventProcedureId);
    },
    [setTouched, setValue, onClose],
  );

  const handleRemove = React.useCallback(() => {
    setValue('');
    setTouched(true);
    onRemove?.();
  }, [onRemove, setTouched, setValue]);

  if (loadingEventProcedure) return <Spinner text="Loading" />;

  if (remediationSteps) INIT_EVENT_PROCEDURE.description = remediationSteps;

  return (
    <Form
      eventProcedure={eventProcedure || INIT_EVENT_PROCEDURE}
      onSave={onChange}
      onCancel={onClose}
      onDelete={handleRemove}
    />
  );
}

export default EventProcedureFormField;
